import { ReactElement } from 'react';

import SkeletonProvider from '^components/common/SkeletonProvider';
import useCarVariantColors from '^hooks/useCarVariantColors';
import ColorChooser from '^components/common/ColorChooser';
import ErrorProvider from '^components/ErrorProvider';

const CarColorViewer = (): ReactElement => {
  const { list, areLoading, hasError } = useCarVariantColors();

  return (
    <SkeletonProvider isLoaderShown={areLoading}>
      <ErrorProvider hasError={hasError}>
        <ColorChooser colors={list} />
      </ErrorProvider>
    </SkeletonProvider>
  );
};

export default CarColorViewer;
